export const IMG_URL = 'https://api.icarda.ajatus.in/uploads/';